import { styled } from '@mui/material';

export const HeaderSubtitle = styled('p')(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.mode === 'dark' ? '#b5b5b5' : '#515151',
  margin: 0,
  whiteSpace: 'pre-wrap',
  textAlign: 'left',
}));

export const OptionsContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
});

export const OptionItem = styled('div')(
  ({ theme, $isSelected, $isDisabled }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '16px',
    borderRadius: '8px',
    cursor: $isDisabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.2s ease',
    // backgroundColor: theme.palette.mode === 'dark' ? '#262626' : '#FFFFFF',
    opacity: $isDisabled ? 0.5 : 1,
    pointerEvents: $isDisabled ? 'none' : 'auto',
    border: `1px solid ${
      $isSelected
        ? theme.palette.mode === 'dark'
          ? '#70c4f7'
          : '#0486d7'
        : theme.palette.mode === 'dark'
          ? '#464646'
          : '#e5e5e5'
    }`,
    '&:hover': {
      borderColor: $isDisabled
        ? undefined
        : theme.palette.mode === 'dark'
          ? '#70c4f7'
          : '#0486d7',
    },
  })
);

export const OptionContent = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flex: 1,
});

export const CreditAmount = styled('span')(({ theme, $isSelected }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '16px',
  lineHeight: 'normal',
  color: $isSelected
    ? theme.palette.mode === 'dark'
      ? '#ffffff'
      : '#1a1b1f'
    : theme.palette.mode === 'dark'
      ? '#c6c6c6'
      : '#787878',
}));

export const OptionTextLabel = styled('span')(({ theme, $isSelected }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '14px',
  color: $isSelected
    ? theme.palette.mode === 'dark'
      ? '#ffffff'
      : '#787878'
    : theme.palette.mode === 'dark'
      ? '#c6c6c6'
      : '#787878',
}));

export const OptionPrice = styled('div')(({ theme, $isSelected }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '16px',
  fontWeight: $isSelected ? 600 : 400,
  color: $isSelected
    ? theme.palette.mode === 'dark'
      ? '#70c4f7'
      : '#0486d7'
    : theme.palette.mode === 'dark'
      ? '#c6c6c6'
      : '#919191',
}));

export const SummarySection = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#2C2C2C' : '#f9fcff',
  borderRadius: '10px',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '84px',
  width: '100%',
  boxSizing: 'border-box',
  marginTop: '10px',
}));

export const SummaryRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 0,
  width: '100%',
  justifyContent: 'space-between',
});

export const SummaryTextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
});

export const PurchasingLabel = styled('p')(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 600,
  fontSize: '14px',
  color: theme.palette.text.primary,
  margin: 0,
}));

export const PurchasingDetails = styled('div')({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
});

export const DetailItem = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontFamily: "'Poppins', sans-serif",
});

export const DetailLabel = styled('span')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.mode === 'dark' ? '#888' : '#787878',
}));

export const DetailValue = styled('span')(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 500,
  color: theme.palette.mode === 'dark' ? '#ccc' : '#515151',
}));

export const DetailUnit = styled('span')(({ theme }) => ({
  fontSize: '10px',
  color: theme.palette.mode === 'dark' ? '#888' : '#787878',
}));

export const TotalPrice = styled('span')(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 500,
  color: theme.palette.text.primary,
  '& > span:first-child': {
    color: theme.palette.mode === 'dark' ? '#888' : '#787878',
    marginRight: '4px',
  },
}));

export const WarningContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '16px',
  gap: '12px',
  borderRadius: '10px',
  border: '1px solid #FEE685',
  backgroundColor: theme.palette.mode === 'dark' ? 'transparent' : '#FFFBEB',
  width: '100%',
  marginTop: '16px',
}));

export const WarningText = styled('p')(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '21px',
  color: theme.palette.mode === 'dark' ? '#fff' : '#1a1b1f',
  margin: 0,
  textAlign: 'left',
}));

export const ExtraCreditsOneTimeWarning = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  padding: '8px 12px',
  gap: '8px',
  borderRadius: '8px',
  border: '1px solid #f6daab',
  backgroundColor: '#fcf5e8',
  width: '100%',
  marginTop: '16px',
  marginBottom: '16px',
});

export const WarningIconContainer = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  flexShrink: 0,
});

export const WarningContent = styled('p')({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: 'normal',
  color: '#1a1b1f',
  margin: 0,

  flex: 1,
  textAlign: 'left',
});
